import React from 'react';
import { methods } from '../../config/invoiceBlock';

const NotPaidContent = ({ type, sum, paymentState, isFinal }) => {
  return (
    <>
      {methods.createContent({ type, sum })}
      {isFinal && paymentState ? <span>{paymentState.name}</span> : null}
    </>
  );
};

export default NotPaidContent;
